"use client";

import { Header } from "@/app/(store)/_components/header";
import { cartAnalitica, productAnalitica } from "@/app/(store)/_utils/events";

function HeaderSlotCatchAll() {
  return (
    <Header
      actions={{
        search: true,
        whatsApp: {
          analiticaEvent: productAnalitica.events.share.whatsappHeader,
        },
        cart: {
          analiticaEvent: () =>
            cartAnalitica.events.action.headerClicked("Página de produto"),
        },
      }}
      navigation={{
        homeLink: {
          onClick: () => productAnalitica.events.action.homeClicked(),
        },
      }}
      collapsed
    />
  );
}

export default HeaderSlotCatchAll;
